import { PersonaId } from '../../personas';
import { PERSONA_MOCKS } from '../persona-mocks';
import * as styled from '../styles/social-bios';
import { FacebookCard } from './facebook-card';
import { InstagramCard } from './instagram-card';
import { TikTokCard } from './tiktok-card';
import { WhatsAppCard } from './whatsapp-card';

const CARD_PEOPLE = {
  instagram: {
    name: 'Jonny',
    initials: 'J',
    slug: 'john',
    profession: 'Plumber',
  },
  tiktok: {
    name: 'Mia L.',
    initials: 'ML',
    slug: 'mia',
    profession: 'Content Creator',
  },
  facebook: { name: 'Aria R.', initials: 'AR', slug: 'aria' },
  whatsapp: { name: 'Theo W.', initials: 'TW', slug: 'theo' },
} as const;

type Props = {
  personaId: PersonaId;
};

const PULSE_OFFSET_TIKTOK_MS = 0;
const PULSE_OFFSET_FACEBOOK_MS = -800;
const PULSE_OFFSET_WHATSAPP_MS = -1600;

export const SocialBios = ({ personaId }: Props) => {
  const personaProfession = PERSONA_MOCKS[personaId].professionLine;

  const cardContent = (
    person: (typeof CARD_PEOPLE)[keyof typeof CARD_PEOPLE],
  ): Landing.SocialBioCardContent => ({
    initials: person.initials,
    name: person.name,
    profession:
      'profession' in person ? person.profession : personaProfession,
    slug: person.slug,
  });

  return (
    <styled.Wrap>
      <styled.Callout>
        <styled.CalloutTitle>Don't be Jonny.</styled.CalloutTitle>
        <styled.CalloutSub>
          With just a gmail in his bio, he <styled.CalloutBad>looks like a scammer</styled.CalloutBad>.{' '}
          <styled.CalloutGood>Real reviews</styled.CalloutGood> and a{' '}
          <styled.CalloutGood>real profile</styled.CalloutGood>? Clients{' '}
          <styled.CalloutGood>book without thinking twice</styled.CalloutGood>.
        </styled.CalloutSub>
      </styled.Callout>
      <styled.Grid>
        <InstagramCard {...cardContent(CARD_PEOPLE.instagram)} phase="bad" />
        <TikTokCard
          {...cardContent(CARD_PEOPLE.tiktok)}
          phase="good"
          enterDelay={PULSE_OFFSET_TIKTOK_MS}
        />
        <FacebookCard
          {...cardContent(CARD_PEOPLE.facebook)}
          phase="good"
          enterDelay={PULSE_OFFSET_FACEBOOK_MS}
        />
        <WhatsAppCard
          {...cardContent(CARD_PEOPLE.whatsapp)}
          phase="good"
          enterDelay={PULSE_OFFSET_WHATSAPP_MS}
        />
      </styled.Grid>
    </styled.Wrap>
  );
};
